const { getOffsetTop } = window.BAO.Utils

class StickyScroll extends window.BAO.CustomElement() {
  connectedCallback () {
    super.connectedCallback()

    if (!window.BAO.MediaBreakpoints.isSm) return

    this.isTicking = false
    this.lastKnownY = window.scrollY
    this.scrollDirection = ''
    this.scrollDirectionPrevious = ''

    this.requestTick = this.requestTick.bind(this)
    this.updateEl = this.updateEl.bind(this)

    this.updateEl()
  }

  setupListeners () {
    super.setupListeners()

    if (!window.BAO.MediaBreakpoints.isMd) return

    this.onScroll = this.onScroll.bind(this)

    this.listeners.add(window, 'scroll', this.onScroll)

    window.BAO.eventBus.addEventListener(
      window.BAO.EVENTS.PRODUCT.OPTION_CHANGED,
      this.onScroll,
    )
  }

  onScroll () {
    const previouslyKnown = this.lastKnownY
    this.scrollDirectionPrevious = this.scrollDirection

    this.lastKnownY = window.scrollY
    this.scrollDirection = previouslyKnown < this.lastKnownY ? 'down' : 'up'

    this.requestTick()
  }

  requestTick () {
    if (!this.isTicking) requestAnimationFrame(this.updateEl)

    this.isTicking = true
  }

  updateEl () {
    this.isTicking = false

    this.setSticky()
  }

  setSticky () {
    if (!this.els?.container?.exists) return

    const containerHeight = this.els.container.element.offsetHeight
    const contentHeight = this.els.content.element.offsetHeight

    if (containerHeight > contentHeight && window.innerHeight < contentHeight) {
      this.classList.toggle('prd-Detail_Columns-defaultSticky', false)

      const offsetAmount = window.innerHeight - contentHeight

      if (this.scrollDirectionPrevious !== this.scrollDirection) {
        const containerOffsetTop = getOffsetTop(this.els.container.element)
        const contentOffsetTop = getOffsetTop(this.els.content.element)

        this.els.spacer.element.style.setProperty(
          'margin-top',
          `${contentOffsetTop - containerOffsetTop}px`,
        )
      }

      if (this.scrollDirection === 'down') {
        this.els.content.element.style.setProperty('top', `${offsetAmount}px`)
        this.els.content.element.style.removeProperty('bottom')
      } else {
        this.els.content.element.style.setProperty(
          'bottom',
          `${offsetAmount}px`,
        )

        this.els.content.element.style.removeProperty('margin-top')
      }
    } else {
      this.classList.toggle('prd-Detail_Columns-defaultSticky', true)
      this.els.content.element.style.removeProperty('top')
      this.els.content.element.style.removeProperty('bottom')
      this.els.spacer.element.style.removeProperty('margin-top')
    }
  }
}

if (!customElements.get('sticky-scroll')) {
  customElements.define('sticky-scroll', StickyScroll)
}
